import { useQuery } from '@apollo/client';
import * as R from 'ramda';
import { ApolloProviderV4 } from '~/apollo/client-v4';
import { BookmarkParentType } from '~/apollo/generated/v3/graphql';
import { graphql } from '~/apollo/generated/v4';
import { NotFound } from '~/components/common/NotFound';
import { SpinnerPlaceholder } from '~/components/common/SpinnerPlaceholder';
import { SOItemListV4 } from '~/components/supporting-object/so-item-list-v4';
import { TaggedSOItemListV4 } from '~/components/supporting-object/tagged-so-item-list-v4';
import { useRouteParam } from '~/hooks/routing';
import { createRefetchQueries } from '~/utils/graphql';

const OUTCROP_WELL_LOGS_ROUTE = graphql(`
  query OutcropWellLogsRoute($id: ID!) {
    outcropGet(id: $id) {
      id
      wellLogs {
        ...wellLogParts
        pictures {
          ...soPictureParts
        }
        files {
          ...fileParts
        }
        georeferences {
          ...georeferenceParts
        }
      }

      studies {
        ...studyParts
        wellLogs {
          ...wellLogParts
          pictures {
            ...soPictureParts
          }
          files {
            ...fileParts
          }
          georeferences {
            ...georeferenceParts
          }
        }
      }
    }
  }
`);

export default function OutcropWellLogsPage() {
  return (
    <ApolloProviderV4>
      <OutcropWellLogsPageInner />
    </ApolloProviderV4>
  );
}

function OutcropWellLogsPageInner() {
  const outcropId = useRouteParam('outcropId', parseInt);

  const { data, loading } = useQuery(OUTCROP_WELL_LOGS_ROUTE, {
    variables: { id: outcropId },
  });

  const refetchQueries = createRefetchQueries([
    { query: OUTCROP_WELL_LOGS_ROUTE, variables: { id: outcropId } },
  ]);

  const outcrop = data?.outcropGet;
  const wellLogs = outcrop?.wellLogs ?? [];
  const outcropStudies = R.sortBy(s => s.name, outcrop?.studies ?? []);

  if (loading) return <SpinnerPlaceholder />;
  if (!outcrop) return <NotFound />;

  return (
    <>
      <SOItemListV4
        items={wellLogs}
        soParentType="outcrop"
        soParentId={outcropId}
        bookmarkParentType={BookmarkParentType.WellLog}
        refetchQueries={refetchQueries}
      />

      <TaggedSOItemListV4
        outcropId={outcropId}
        studies={outcropStudies}
        supportObjectKey="wellLogs"
        refetchQueries={refetchQueries}
      />
    </>
  );
}
